import React, { useState } from "react";
import InputRange from "react-input-range";
import "react-input-range/lib/css/index.css";
import { useDispatch, useSelector } from "react-redux";
import { t } from "i18next";
import ReactTooltip from "react-tooltip";
import { BsInfoCircle } from "react-icons/bs";
import { useEffect } from "react";
import { startRegisterSearchInfo } from "../../app/actions/searchInfoActions";
import { setPreviousSearchParams } from "../../app/actions/searchHistoryActions";
import { dispatchModulePaginatedSearch } from "../../app/helpers/moduleSearch.helper";

const PercentajeReactInputRange = ({
  indicator_name,
  dataList,
  title,
  keyCatalog,
  searchTextState,
  catalogsToFilter,
  setCatalogsToFilter,
  itemsPerPage,
  setItemsPerPage,
  valueMin,
  valueMax,
  moduleSelected,
    catalogCiiuLevel1Selected,
  indicatorsToFilter,
  setIndicatorsToFilter,
  groupVisionSelected
}) => {
  const dispatch = useDispatch();

  const { user } = useSelector((state) => state.auth);

  const [rango, setRango] = useState({ min: valueMin, max: valueMax });

  useEffect(() => {
    setRango({ min: valueMin, max: valueMax })
  }, [valueMin, valueMax])

  const handleReloadInformation = (min, max) => {

    let indicatorsToFilterList = [];
    indicatorsToFilterList =
      indicatorsToFilter && indicatorsToFilter.length > 0
        ? [...indicatorsToFilter]
        : [];

    let indicatorToFilterObjet = {};

    switch (indicator_name) {
      case "deep_indicator":
        indicatorToFilterObjet = {
          columnIndicator: indicator_name,
          valueIndicatorMin: min,
          valueIndicatorMax: max,
        };

        break;

      case "protection_indicator":
        indicatorToFilterObjet = {
          columnIndicator: indicator_name,
          valueIndicatorMin: min,
          valueIndicatorMax: max,
        };

        break;

      case "applicability_indicator":
        indicatorToFilterObjet = {
          columnIndicator: indicator_name,
          valueIndicatorMin: min,
          valueIndicatorMax: max,
        };

        break;

      case "relevance_indicator":
        indicatorToFilterObjet = {
          columnIndicator: indicator_name,
          valueIndicatorMin: min,
          valueIndicatorMax: max,
        };

        break;

      case "mitigation_indicator":
        indicatorToFilterObjet = {
          columnIndicator: indicator_name,
          valueIndicatorMin: min,
          valueIndicatorMax: max,
        };

        break;

      case "adaptation_indicator":
        indicatorToFilterObjet = {
          columnIndicator: indicator_name,
          valueIndicatorMin: min,
          valueIndicatorMax: max,
        };

        break;

      case "performance_indicator":
        indicatorToFilterObjet = {
          columnIndicator: indicator_name,
          valueIndicatorMin: min,
          valueIndicatorMax: max,
        };

        break;

      default:
        break;
    }

    const indicator_id_object =
      indicatorsToFilterList &&
      indicatorsToFilterList.length > 0 &&
      indicatorsToFilterList.find((element) =>
        element.columnIndicator === indicator_name
      );

    if (!!indicator_id_object) {

      if (
        indicator_id_object.valueIndicatorMin ===
        indicatorToFilterObjet.valueIndicatorMin &&
        indicator_id_object.valueIndicatorMax ===
        indicatorToFilterObjet.valueIndicatorMax
      ) {

      } else {

        const index = indicatorsToFilterList.findIndex(
          (objeto) => objeto.columnIndicator === indicator_name
        );

        if (index !== -1) {

          indicatorsToFilterList[index] = {

            columnIndicator: indicator_name,
            valueIndicatorMin: min,
            valueIndicatorMax: max,
          };
        }

        setIndicatorsToFilter(indicatorsToFilterList);

        /*******> SEARCH_INFO <*******/
        const searchInfo = {
          text_search: searchTextState,
          indicators: indicatorsToFilterList,
          filters: catalogsToFilter,
          catalogmodule_id: moduleSelected.id,
          user_id: user.user_id,
          deleted: false
        }

        dispatch(startRegisterSearchInfo(searchInfo));

        //JT PAGE agrego size
        dispatch(setPreviousSearchParams({
          searchText: searchTextState,
          page: 0,
          size: itemsPerPage,
          catalogsToFilter: catalogsToFilter,
          indicatorsToFilter: indicatorsToFilterList,
          catalogModule: moduleSelected || {},
          catalogCiiuLevel1: catalogCiiuLevel1Selected || {},
          groupVision: groupVisionSelected || {}
        }));

        // Preparas los parámetros
            const searchParams = {
              searchText: searchTextState,
              moduleKey: moduleSelected?.key,
              page: 0,
              itemsPerPage: itemsPerPage,
              catalogsToFilter: catalogsToFilter,
              indicatorsToFilter: indicatorsToFilterList,
              codeCiiuLevel1: catalogCiiuLevel1Selected?.code || null
            };
        
            // Ejecutas el helper genérico
            dispatchModulePaginatedSearch(dispatch, searchParams);

      }
    } else {

      indicatorsToFilterList.push(indicatorToFilterObjet);

      setIndicatorsToFilter(indicatorsToFilterList);

      /*******> SEARCH_INFO <*******/
      const searchInfo = {
        text_search: searchTextState,
        indicators: indicatorsToFilterList,
        filters: catalogsToFilter,
        catalogmodule_id: moduleSelected.id,
        user_id: user.user_id,
        deleted: false
      }

      dispatch(startRegisterSearchInfo(searchInfo));

      //JT PAGE agrego size
        dispatch(setPreviousSearchParams({
          searchText: searchTextState,
          page: 0,
          size: itemsPerPage,
          catalogsToFilter: catalogsToFilter,
          indicatorsToFilter: indicatorsToFilterList,
          catalogModule: moduleSelected || {},
          catalogCiiuLevel1: catalogCiiuLevel1Selected || {},
          groupVision: groupVisionSelected || {}
        }));

        // Preparas los parámetros
            const searchParams = {
              searchText: searchTextState,
              moduleKey: moduleSelected?.key,
              page: 0,
              itemsPerPage: itemsPerPage,
              catalogsToFilter: catalogsToFilter,
              indicatorsToFilter: indicatorsToFilterList,
              codeCiiuLevel1: catalogCiiuLevel1Selected?.code || null
            };
        
            // Ejecutas el helper genérico
            dispatchModulePaginatedSearch(dispatch, searchParams);

    }
  };

  const handleOnChangeComplete = (value) => {

    if (value) {
      const { min, max } = value;

      setTimeout(() => {
        handleReloadInformation(min, max);
      }, 2000);
    }
  };

  return (
    <div className="percentGroup">
      <div style={{ display: "flex", alignItems: "center" }}>
        <span
          htmlFor={indicator_name}
          className="tit-view viewContentTitIndicator"
        >
          {t(
            `${moduleSelected &&
            moduleSelected.key &&
            moduleSelected.key
            }.indicator.${indicator_name}`
          )}
        </span>
        <BsInfoCircle
          style={{ marginLeft: "5px" }}
          data-tip
          data-for={`${indicator_name}_tip`}
        />
      </div>

      <InputRange
        name={indicator_name}
        id={indicator_name}
        maxValue={valueMax}
        minValue={valueMin}
        value={rango}
        onChange={(value) => setRango(value)}

        onChangeComplete={(value) => handleOnChangeComplete(value)}
      />

      <div>
        {/*Rango seleccionado: <span className="rango-seleccionado">{rango.min} - {rango.max}</span>*/}
      </div>

      <ReactTooltip id={`${indicator_name}_tip`} place="left" effect="solid">
        {t(
          `${moduleSelected &&
          moduleSelected.key &&
          moduleSelected.key
          }.short.${indicator_name}`
        )}
      </ReactTooltip>
    </div>
  );
};

export default PercentajeReactInputRange;
